import React from 'react';

const ProfilePage = () => {
  return (
    <div className="container section">
      <h1>My Profile</h1>
      <p>Manage your account settings and preferences.</p>
    </div>
  );
};

export default ProfilePage;
